import { render, staticRenderFns } from "./history_logs_page.vue?vue&type=template&id=3c0aae49&scoped=true"
import script from "./history_logs_page.vue?vue&type=script&lang=js"
export * from "./history_logs_page.vue?vue&type=script&lang=js"
import style0 from "./history_logs_page.vue?vue&type=style&index=0&id=3c0aae49&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0aae49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0aae49')) {
      api.createRecord('3c0aae49', component.options)
    } else {
      api.reload('3c0aae49', component.options)
    }
    module.hot.accept("./history_logs_page.vue?vue&type=template&id=3c0aae49&scoped=true", function () {
      api.rerender('3c0aae49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/history_logs_page.vue"
export default component.exports